import { memo } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PendingIcon from '@material-ui/icons/HourglassEmpty';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { WarningIcon } from '../icons/WarningIcon';
import Badge from './Badge';
import './styles/statusBadge.css';

interface StatusConfig {
  text: string;
  className: string;
  icon: React.ReactNode;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  // CREATE operation statuses
  SUBMITTED: {
    text: 'Submitted',
    className: 'pc-badge-status-submitted',
    icon: <PendingIcon />,
  },
  FAILED: {
    text: 'Failed',
    className: 'pc-badge-status-failed',
    icon: <WarningIcon />,
  },
  FAILED_LOGIN: {
    text: 'Login Failed',
    className: 'pc-badge-status-failed',
    icon: <WarningIcon />,
  },
  SUCCESSFUL: {
    text: 'Ready',
    className: 'pc-badge-status-ready',
    icon: <CheckCircleIcon />,
  },

  PROCESSING: {
    text: 'Processing',
    className: 'pc-badge-status-processing',
    icon: <ScheduleIcon />,
  },
  GENERATING: {
    text: 'Generating',
    className: 'pc-badge-status-processing',
    icon: <ScheduleIcon />,
  },
  GENERATE_SUCCESSFUL: {
    text: 'Generate Successful',
    className: 'pc-badge-status-generate-successful',
    icon: <CheckCircleIcon />,
  },
  GENERATE_FAILED: {
    text: 'Generate Failed',
    className: 'pc-badge-status-generate-failed',
    icon: <WarningIcon />,
  },
  EXECUTING: {
    text: 'Executing',
    className: 'pc-badge-status-processing',
    icon: <ScheduleIcon />,
  },
  EXECUTE_SUCCESSFUL: {
    text: 'Execute Successful',
    className: 'pc-badge-status-ready',
    icon: <CheckCircleIcon />,
  },
  EXECUTE_FAILED: {
    text: 'Execute Failed',
    className: 'pc-badge-status-failed',
    icon: <WarningIcon />,
  },
  ENHANCING: {
    text: 'Enhancing',
    className: 'pc-badge-status-processing',
    icon: <ScheduleIcon />,
  },
  ENHANCE_SUCCESSFUL: {
    text: 'Enhance Successful',
    className: 'pc-badge-status-ready',
    icon: <CheckCircleIcon />,
  },
  ENHANCE_FAILED: {
    text: 'Enhance Failed',
    className: 'pc-badge-status-failed',
    icon: <WarningIcon />,
  },
  DEFAULT: {
    text: 'Unknown',
    className: 'pc-badge-status-failed',
    icon: <WarningIcon />,
  },
};

const StatusBadge = memo(({ status }: { status?: string }) => {
  const config = (status && STATUS_CONFIG[status]) || STATUS_CONFIG.DEFAULT;
  return (
    <Badge text={config.text} className={config.className} icon={config.icon} />
  );
});

export default StatusBadge;
